import { render, staticRenderFns } from "./editPrivacypolicy.vue?vue&type=template&id=d61513d8&"
import script from "./editPrivacypolicy.vue?vue&type=script&lang=js&"
export * from "./editPrivacypolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports